<div class="contianer-fluid p-0">
    <div class="workspaceNewTabContent">
        <div class="row">
            <div class="empty-workspace-header px-2">
                <cv-dashboard-header class="col-6"></cv-dashboard-header>
                <div *ngIf="dashboardService?.getActiveDashboard() == null" class="workspace-header-button col-6 d-flex align-content-center">
                    <div #createDropdown="ngbDropdown" ngbDropdown *ngIf="hasCreatePermission()">
                        <button type="button" class="btn header-btn ml-0 sub-menu-button" ngbDropdownToggle>
                            <span cvLocalizedText langSection="Dashboards_Landing" langKey="Create_Dashboard">Create Dashboard</span>
                            <svg class="icon-12 dropdown-menu-icon arrow-margin">
                                <use href="../App_Themes/CXone/icons/arrow-down.svg#arrow-down"></use>
                            </svg>
                        </button>
                        <ul ngbDropdownMenu>
                            <li ngbDropdownItem>
                                <button type="button" class="btn dropdown-menu-item" *ngIf="hasCreatePermission" cvLocalizedText langSection="Dashboards_Landing" langKey="New"
                                    (click)="createNewDashboard(dashboardService.getActiveDashboard(), dashboardService.workspaceKey)">New
                                </button>
                            </li>
                            <li ngbDropdownItem>
                                <button type="button" class="btn dropdown-menu-item" (click)="openFromTemplate()" *ngIf="hasCreatePermission" 
                                    cvLocalizedText langSection="Dashboards_Landing" langKey="From_Template">From Template
                                </button>
                            </li>
                        </ul>
                    </div>  
                </div>
            </div>
        </div>
        <div class="row">
            <div class="empty-workspace-container">
                <svg class="mb-1">
                    <use href="../App_Themes/CXone/icons/add-dashboard.svg#add-dashboard"></use>
                </svg>
                <div class="empty-workspace-message" cvLocalizedText [langSection]="'CXOne_Dashboard'" [langKey]="'No_Dashboards'">No dashboards selected</div>
            </div>
        </div> 
    </div>
</div>
